import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <h2 className="footer-logo">Alainn</h2>
          <p className="footer-tagline">Est. 2024</p>
          <p className="footer-desc">
            A curated edit of the world's most considered clothing.
            Each piece chosen for longevity, craft, and quiet beauty.
          </p>
        </div>
        <div className="footer-links">
          <div className="footer-col">
            <h4 className="col-title">Shop</h4>
            <Link to="/shop?cat=Dresses" className="footer-link">Dresses</Link>
            <Link to="/shop?cat=Tops" className="footer-link">Tops</Link>
            <Link to="/shop?cat=Knitwear" className="footer-link">Knitwear</Link>
            <Link to="/shop?cat=Outerwear" className="footer-link">Outerwear</Link>
            <Link to="/shop?cat=Denim" className="footer-link">Denim</Link>
            <Link to="/shop?cat=Swimwear" className="footer-link">Swimwear</Link>
          </div>
          <div className="footer-col">
            <h4 className="col-title">Accessories</h4>
            <Link to="/shop?cat=Shoes" className="footer-link">Shoes</Link>
            <Link to="/shop?cat=Bags" className="footer-link">Bags</Link>
            <Link to="/shop?cat=Jewellery" className="footer-link">Jewellery</Link>
            <Link to="/shop?cat=Accessories" className="footer-link">Scarves & Hats</Link>
            <Link to="/shop?cat=Loungewear" className="footer-link">Loungewear</Link>
          </div>
          <div className="footer-col">
            <h4 className="col-title">Help</h4>
            <a href="#" className="footer-link">Size Guide</a>
            <a href="#" className="footer-link">Shipping & Returns</a>
            <a href="#" className="footer-link">Care Guide</a>
            <a href="#" className="footer-link">Contact</a>
          </div>
          <div className="footer-col">
            <h4 className="col-title">The Brand</h4>
            <a href="#" className="footer-link">Our Story</a>
            <a href="#" className="footer-link">Sustainability</a>
            <a href="#" className="footer-link">Craftspeople</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="footer-copy">© {new Date().getFullYear()} Alainn. All rights reserved.</p>
        <p className="footer-made">Made with intention.</p>
      </div>
    </footer>
  );
}
